var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.262,
    height: 14.61,
    viewBox: "0 0 18.262 14.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt-slash",
    "data-name": "Icon awesome-user-alt-slash",
    d: "M18.087,13.072,11.118,7.684a4.1,4.1,0,1,0-5.952-4.6L1.3.1a.458.458,0,0,0-.642.08L.1.9a.455.455,0,0,0,.08.639L16.968,14.51a.458.458,0,0,0,.642-.08l.559-.722a.452.452,0,0,0-.083-.636ZM5.663,9.131a3.836,3.836,0,0,0-3.835,3.835v.274A1.37,1.37,0,0,0,3.2,14.61H14.1L7.015,9.131Z",
    transform: "translate(-0.002)",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSlash);
export default __webpack_public_path__ + "static/media/userSlash.3dcf3cce26f2c84de7ad03c9a02736e2.svg";
export { ForwardRef as ReactComponent };